<div class="row">
    <div *ngIf="!AllDescount;then NoDescount else Descount"></div>

    <ng-template #NoDescount>
        <div class="col-md-12">
            <p> {{ 'NoDataFound' | translate}}</p>
        </div>
    </ng-template>

    <ng-template #Descount>
        <div class="col-md-12">
            <mat-tab-group>
                <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden" *ngIf="AllDescount">
                    <mat-tab *ngFor="let dis of AllDescount| keyvalue" label="{{dis.key}}">
                        <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                            <mat-card-content class="mat-mdc-card-content">
                                <div class="col-md-12" *ngFor="let value of dis.value">
                                    <div *ngIf="!value;then NoData else Data"></div>

                                    <ng-template #NoData>
                                        <p> {{ 'NoProductsContracts' | translate}}</p>
                                    </ng-template>

                                    <ng-template #Data>
                                        <div *ngIf="value.typeofCategoryName">
                                            <span class="spanCategoryName"> {{ value.typeofCategoryName }} : </span>
                                            <span> {{ value.descount }}</span>
                                            <span> {{ value.typeDescountName }}</span>
                                        </div>
                                    </ng-template>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </mat-tab>
                </mat-card>
            </mat-tab-group>
        </div>
    </ng-template>
</div>